export default "__VITE_ASSET__ChB4xd9Z__"